import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { HeaderStyleOneComponent } from '../../common/header-style-one/header-style-one.component';
import { FormsModule, ReactiveFormsModule, FormGroup, FormControl, Validators } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import Swal from 'sweetalert2';
import { Apiservice } from 'src/app/services/apiservice';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-login-page',
    standalone: true,
    imports: [RouterLink, RouterModule, MaterialModule, FormsModule, ReactiveFormsModule],
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit {

    isToggled = false;
    // options = this.settings.getOptions();
    mail = false;
    phnum = true;
    otp = false;
    time: number;
    timer: any;
    images: any = '';
    roletype: any;
    constructor(
        public themeService: ThemeCustomizerService, private router: Router, private login: Apiservice, private cdr: ChangeDetectorRef, private modalService: NgbModal,
    ) {
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    toggleTheme() {
        this.themeService.toggleTheme();
    }

    ngOnInit(): void { }

    navigateUserReg() {
        this.router.navigateByUrl('/registration')
    }

    toPhone() {
        this.mail = false;
        this.phnum = true;
        this.otp = false;
        this.images = ''
        this.numform.reset();
        this.otpform.reset();
        clearInterval(this.timer);
    }

    toMail() {
        this.mail = true;
        this.phnum = false;
        this.otp = false;
    }

    form = new FormGroup({
        uname: new FormControl('', [Validators.required, Validators.minLength(6)]),
        password: new FormControl('', [Validators.required]),
    });

    numform = new FormGroup({
        phonenumber: new FormControl('', [Validators.required, Validators.pattern(/^(?:\+91|91|0)?[6-9]\d{9}$/)]),
    });

    otpform = new FormGroup({
        otpsending: new FormControl('', [Validators.required]),
    });

    get f() {
        return this.form.controls;
    }

    get f1() {
        return this.numform.controls;
    }

    get f2() {
        return this.otpform.controls;
    }
    submitnum() {
        if (this.numform.valid) {
            Swal.fire({
                title: 'Loading...',
                html: 'Please wait while we process your request.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            })
            this.login.sendOtp(this.numform.value).subscribe((res: any) => {
                console.log(res.status);

                Swal.close();
                if (res.status === 200) {
                    this.mail = false;
                    this.phnum = false;
                    this.otp = true;
                    this.images = res.data[0].image;
                    this.roletype = res.data[0].role_type;
                    this.cdr.detectChanges();
                    this.time = 60;
                    this.timer = setInterval(() => {
                        this.time = this.time - 1;
                        if (this.time == 0) {
                            clearInterval(this.timer);
                            Swal.fire({
                                icon: "warning",
                                title: "OTP Expired"
                            }).then(() => {
                                this.otp = false;
                                this.phnum = true;
                                this.images = ''
                                this.numform.reset();
                                this.otpform.reset();
                            });
                        }
                    }, 1000);
                }
            },
                (err: any) => {
                    console.log(err);
                    if (err?.status == 429) {
                        Swal.close();
                        this.numform.reset();
                        Swal.fire({
                            title: err.error.error,
                            icon: "error"
                        })
                    }
                    else {
                        Swal.close();
                        // this.numform.reset();
                        // Swal.fire({
                        //   title: "Not a Valid User",
                        //   icon: "error"
                        // })
                        Swal.close();
                        // this.numform.reset();
                        // Swal.fire({
                        //   title: "Not a Valid User",
                        //   icon: "error"
                        // })
                        this.time = 60;
                        this.timer = setInterval(() => {
                            this.time = this.time - 1;
                            if (this.time == 0) {
                                clearInterval(this.timer);
                                Swal.fire({
                                    icon: "warning",
                                    title: "OTP Expired"
                                }).then(() => {
                                    this.otp = false;
                                    this.phnum = true;
                                    this.images = ''
                                    this.numform.reset();
                                    this.otpform.reset();
                                });
                            }
                        }, 1000);
                        this.mail = false;
                        this.phnum = false;
                        this.otp = true;
                        this.cdr.detectChanges();
                    }

                }

            )
        }
    }

    submitotp() {
        if (this.otpform.valid) {
            Swal.fire({
                title: 'Loading...',
                html: 'Please wait while we process your request.',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            })
            this.login.verifyOtp({ ...this.otpform.value, ...this.numform.value }).subscribe({
                next: (res: any) => {
                    console.log(res, "130");
                    if (res.data.id) {
                        // this.authService.setAccessToken(res.data.id);
                        localStorage.setItem('access_token', res.data.id)
                        const decoded = this.decodeJWT(res.data.id);
                        let token = localStorage.getItem('access_token');
                        console.log(token);

                        // if (token) {
                        // const decoded = this.decodeJWT(token);
                        let obj = {
                            name: decoded.username,
                            image: decoded.image,
                            des: decoded.designation,
                            user_id: decoded.id,
                            role_type: decoded.role,
                            // }
                        };
                        Swal.close();
                        this.modalService.dismissAll();
                        this.login.setUserData(obj);
                        if (res.data.registration_status != 0) {
                            this.router.navigate(['/'], { replaceUrl: true })
                        } else {
                            this.router.navigate(['/registration'], { replaceUrl: true })
                        }


                        // localStorage.setItem('name', decoded.username)
                        // localStorage.setItem('image', decoded.image)
                        // localStorage.setItem('des', decoded.designation)
                        // localStorage.setItem('user_id', decoded.id)
                        // localStorage.setItem('role_type', decoded.role);
                        //  localStorage.setItem('token', res.data.id);
                        // var roles: any = localStorage.getItem('role_type');
                        // if (decoded.role == 1) {


                        // }
                        // else {
                        //   this.router.navigate(['/user'])
                        // }
                        //service call

                        // Swal.close();
                        // localStorage.setItem('access_token', res.data.id);
                        // if (!this.cksrv.cookieCheck("UID")) {
                        //     this.cksrv.login = true;
                        //     // this.cksrv.cookieSet("UID", res.data.refreshToken, { path: "/", expires: 0.5 });
                        //     clearInterval(this.timer);
                        // }
                        // else {
                        //     this.cksrv.cookieDel("UID");
                        // }
                    }
                    else {
                        this.otpform.reset();
                        Swal.fire({
                            icon: "error",
                            title: "Invalid OTP"
                        })
                    }
                },
                error: (err: any) => {
                    this.otpform.reset()
                    Swal.close();
                    Swal.fire({
                        title: "Invalid OTP",
                        text: 'Please Check your phone number or OTP Properly',
                        icon: "error"
                    })
                }
            });
        }


    }
    private decodeJWT(token: string): any {
        try {
            const base64Url = token.split('.')[1]; // Extract the payload part
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/'); // Convert to Base64
            const jsonPayload = decodeURIComponent(
                atob(base64)
                    .split('')
                    .map((c) => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
                    .join('')
            );
            return JSON.parse(jsonPayload); // Parse the payload as JSON
        } catch (error) {
            console.error('Invalid JWT Token', error);
            return null;
        }
    }
    numctrl(ke: any) {
        if (ke.key.charCodeAt() < 48 || ke.key.charCodeAt() > 57) {
            ke.preventDefault();
        }
    }


}